import React from 'react'
import { useAppProgressIndicatorStyles } from './app-progress-indicator.styles'
import { Backdrop, CircularProgress } from '@material-ui/core'

export const AppProgressIndicator: React.FC = (): React.ReactElement => {
  const { progressIndicator, loaderWrapper } = useAppProgressIndicatorStyles()
  return (
    <Backdrop
      open={true}
      className={progressIndicator}
      style={{ zIndex: 100000 }}
    >
      <div className={loaderWrapper}>
        <CircularProgress color="primary" />
      </div>
    </Backdrop>
  )
}
